import { toast } from 'react-hot-toast';
import { useQuery } from 'react-query';

import {
  EntityBlurbRequestParams,
  EntityBlurbResponse,
  TOPIC_DESCRIPTION_KEY,
  fetchEntityBlurb,
} from '../utils/backend-api/entities';

export default function useTopicDescription(params: EntityBlurbRequestParams) {
  const { data: topicDescription, isLoading: isLoadingTopicDescription } =
    useQuery<EntityBlurbResponse>(
      TOPIC_DESCRIPTION_KEY,
      async () => await fetchEntityBlurb(params),
      {
        onError: () => {
          toast.error('We are not able process your request. Please try again');
        },
      }
    );
  return { topicDescription, isLoadingTopicDescription };
}
